<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

// Shown instead of a picture we won't make, with an idea we can make instead
const store = useStore();
const refusal = computed(() => store.state.result.refusal);
const useIdea = () => store.dispatch("result/useSafeSuggestion");
</script>

<template>
  <section
    v-if="refusal"
    class="mt-6 rounded-2xl border border-accentSecondary bg-accentSecondaryLight p-5 text-primary"
    role="alert"
  >
    <div class="flex items-start gap-4">
      <img src="/logo.svg" alt="" class="mt-1 h-10 w-10 shrink-0" />
      <div class="min-w-0">
        <p class="font-bold">Let's make something else</p>
        <p class="mt-1 text-sm text-secondary">{{ refusal.message }}</p>
        <template v-if="refusal.suggestion">
          <p class="mt-4 text-xs font-bold uppercase text-secondary">
            How about this instead?
          </p>
          <p class="mt-1 italic [overflow-wrap:anywhere]">
            “{{ refusal.suggestion }}”
          </p>
          <button
            type="button"
            class="mt-3 rounded-lg bg-accentPrimary px-4 py-2 text-sm font-bold uppercase text-white transition-colors hover:bg-purple-400"
            @click="useIdea"
          >
            Use this idea
          </button>
        </template>
        <p v-else class="mt-3 text-sm">Try describing a different picture.</p>
      </div>
    </div>
  </section>
</template>
